import { SortOrder } from "../../../../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Search.Criteria.Options.SortOrder */
export { SortOrder };
import { ResultReductionType } from "../../../../../../../CoStar/Api/FusionSearch/Migrated/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Search.Criteria.Options.ResultReductionType */
export { ResultReductionType };
